import { useState } from "react";
import { enshortenName, maxNameAllowed } from "../utils/string.js";
import { Tooltip } from 'react-tooltip';
import { BlockUserGroups, UnblockUserGroups } from "../repo/GroupsRepo.js";

export function GroupManagementBlockUser({groupId, user}) {
  const [blocked, setBlocked] = useState(user.blocked)

  const handleUserBlockChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      UnblockUserGroups(groupId, user.id)
      setBlocked(false)
    } else {
      BlockUserGroups(groupId, user.id)
      setBlocked(true)
    }
  }

  return (
    <label className="relative inline-flex cursor-pointer items-center gap-3 text-gray-900">
      <input type="checkbox" defaultChecked={!blocked} className="peer sr-only" onChange={handleUserBlockChange}/>
      <div className="peer h-7 w-12 rounded-full bg-slate-300 ring-offset-1 transition-colors duration-200 peer-checked:bg-indigo-600 peer-focus:ring-2 peer-focus:ring-indigo-500"></div>

      <span className="dot absolute top-1 left-1 h-5 w-5 rounded-full bg-white transition-transform duration-200 ease-in-out peer-checked:translate-x-5"></span>
      <span className={`${blocked ? 'text-slate-500 line-through' : ''}`} id={`user-${user.id}`}>
        {enshortenName(user.name)}
      </span>
      <Tooltip anchorSelect={`#user-${user.id}`} place="top" type="dark" effect="float">
        {`${blocked ? 'Bloqueado: ' : ''}${maxNameAllowed(user.name)}`}
      </Tooltip>
    </label>
  );
}
